import React from 'react';
import { Box } from '@mui/material';
export default function Index({
  color,
  size,
  width = '20px',
  height = '20px',
  ...other
}) {
  return (
    <Box
      component="svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      {...other}
      color={color ? color : 'primaryText'}
    >
      <path
        d="M5.55866 11.6667H3.33366C2.41699 11.6667 1.66699 12.4167 1.66699 13.3334V17.5001C1.66699 17.9584 2.04199 18.3334 2.50033 18.3334H5.55866C6.01699 18.3334 6.39199 17.9584 6.39199 17.5001V12.5001C6.39199 12.0417 6.01699 11.6667 5.55866 11.6667Z"
        fill="currentColor"
      />
      <path
        d="M11.1085 8.33325H8.88346C7.9668 8.33325 7.2168 9.08325 7.2168 9.99992V17.4999C7.2168 17.9583 7.5918 18.3333 8.05013 18.3333H11.9418C12.4001 18.3333 12.7751 17.9583 12.7751 17.4999V9.99992C12.7751 9.08325 12.0335 8.33325 11.1085 8.33325Z"
        fill="currentColor"
      />
      <path
        d="M16.6667 14.1667H14.4417C13.9834 14.1667 13.6084 14.5417 13.6084 15.0001V17.5001C13.6084 17.9584 13.9834 18.3334 14.4417 18.3334H17.5001C17.9584 18.3334 18.3334 17.9584 18.3334 17.5001V15.8334C18.3334 14.9167 17.5834 14.1667 16.6667 14.1667Z"
        fill="currentColor"
      />
      <path
        d="M12.5079 4.04173C12.7662 3.7834 12.8662 3.47507 12.7829 3.2084C12.6995 2.94173 12.4412 2.75007 12.0745 2.69173L11.2745 2.5584C11.2412 2.5584 11.1662 2.50007 11.1495 2.46673L10.7079 1.5834C10.3745 0.908398 9.61621 0.908398 9.28288 1.5834L8.84121 2.46673C8.83288 2.50007 8.75788 2.5584 8.72454 2.5584L7.92454 2.69173C7.55788 2.75007 7.30788 2.94173 7.21621 3.2084C7.13288 3.47507 7.23288 3.7834 7.49121 4.04173L8.10788 4.66673C8.14121 4.69173 8.16621 4.79173 8.15788 4.82507L7.98288 5.59173C7.84954 6.16673 8.06621 6.42507 8.20788 6.52507C8.34954 6.62507 8.65788 6.7584 9.16621 6.4584L9.91621 6.01673C9.94954 5.99173 10.0579 5.99173 10.0912 6.01673L10.8329 6.4584C11.0662 6.60007 11.2579 6.64173 11.4079 6.64173C11.5829 6.64173 11.7079 6.57507 11.7829 6.52507C11.9245 6.42507 12.1412 6.16673 12.0079 5.59173L11.8329 4.82507C11.8245 4.7834 11.8495 4.69173 11.8829 4.66673L12.5079 4.04173Z"
        fill="currentColor"
      />
    </Box>
  );
}
